import * as Sentry from '@sentry/react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { GenericErrorBoundary } from '../components/2compounds/GenericErrorBoundary'
import LayoutEditor from '../components/5templates/LayoutEditor'
import AccountDetails from '../features/assets/accounts/Details'
import BuildingDetail from '../features/assets/locations/BuildingDetail'
import LocationDetails from '../features/assets/locations/LocationDetails'
import PeopleDetails from '../features/assets/parties/Details'
import ResourceDetails from '../features/assets/resources/Details'
import ServiceDetails from '../features/assets/services/Details'
import SkillsetDetails from '../features/assets/skillsets/Details'
import DatazoneDetail from '../features/datazones/DatazoneDetail'
import Playground from '../features/datazones/playground'
import ConsumerTabs from '../features/dynamictabs/consumer'
import ProviderTabs from '../features/dynamictabs/provider'
import GroupDetail from '../features/groups/GroupDetail'
import ExecutiveEntityDetail from '../features/executive/EntityDetail'
import GuestConfirm from '../features/signinsignout/GuestConfirm'
import GuestInitiated from '../features/signinsignout/GuestInitiated'
import SignIn from '../features/signinsignout/SignIn'
import AdminDashboard from '../pages/AdminDashboard'
import DashboardDataEntryTab from '../pages/DashboardDataEntryTab'
import DashboardTab from '../pages/DashboardTab'
import Faq from '../pages/Faq'
import MapView from '../pages/MapView'
import UserManagement from '../pages/UserManagement'
import HeatMap from '../pages/heatMap'
import RedirectionControl from '../pages/redirectionControl'
import AddWorkflowRoutes from './AddWorkflowRoutes'
import ApprovalWorkflowRoutes from './ApprovalWorkflowRoutes'
import UtilityRoutes from './UtilityRoutes'

const withErrorBoundary = (element) => (
  <GenericErrorBoundary>{element}</GenericErrorBoundary>
)

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes)

const AppRoutes = () => (
  <SentryRoutes>
    <Route
      path='/login/guests/confirm/*'
      element={withErrorBoundary(<GuestInitiated />)}
    />
    <Route
      path='/login/guests/*'
      element={withErrorBoundary(<GuestConfirm />)}
    />
    <Route path='/login/*' element={withErrorBoundary(<SignIn />)} />
    <Route path='/faq/*' element={<Faq />} />
    <Route
      path='/dashboard/*'
      element={withErrorBoundary(<DashboardTab />)}
    />
    <Route
      path='/dashboardData/*'
      element={withErrorBoundary(<DashboardDataEntryTab />)}
    />
    <Route
      path='/playground/*'
      element={withErrorBoundary(<Playground />)}
    />
    <Route
      path='/user-management/*'
      element={withErrorBoundary(<UserManagement />)}
    />
    <Route path='/home' element={withErrorBoundary(<MapView />)} />
    <Route path='/heatmap' element={withErrorBoundary(<HeatMap />)} />
    <Route
      path='/adminDashBoard/*'
      element={withErrorBoundary(<AdminDashboard />)}
    />
    <Route
      path='/LayoutEditor'
      element={withErrorBoundary(<LayoutEditor />)}
    />
    <Route
      path='/LayoutEditor/:layoutId/*'
      element={withErrorBoundary(<LayoutEditor />)}
    />
    <Route
      path='/groupDetail/:groupId/*'
      element={withErrorBoundary(<GroupDetail createMode={false} />)}
    />
    <Route
      path='/groupCreate/:type/*'
      element={withErrorBoundary(<GroupDetail createMode />)}
    />
    <Route
      path='/datazoneDetail/:datazoneId/*'
      element={withErrorBoundary(<DatazoneDetail createMode={false} />)}
    />
    <Route
      path='/datazoneCreate/:type/:subType/*'
      element={withErrorBoundary(<DatazoneDetail createMode />)}
    />
    <Route
      path='/resourceDetail/:resourceId/*'
      element={withErrorBoundary(<ResourceDetails />)}
    />
    <Route
      path='/executive/entity/:entityId/*'
      element={withErrorBoundary(<ExecutiveEntityDetail />)}
    />
    <Route
      path='/resourceCreate/*'
      element={withErrorBoundary(<ResourceDetails createMode />)}
    />
    <Route
      path='/serviceDetail/:serviceId/*'
      element={withErrorBoundary(<ServiceDetails />)}
    />
    <Route
      path='/serviceCreate/*'
      element={withErrorBoundary(<ServiceDetails createMode />)}
    />
    <Route
      path='/accountDetail/:accountId/*'
      element={withErrorBoundary(<AccountDetails />)}
    />
    <Route
      path='/accountCreate/*'
      element={withErrorBoundary(<AccountDetails createMode />)}
    />
    <Route
      path='/locationDetail/:assetId/*'
      element={withErrorBoundary(<LocationDetails createMode={false} />)}
    />
    <Route
      path='/locationCreate/*'
      element={withErrorBoundary(<LocationDetails createMode />)}
    />
    <Route
      path='/BuildingDetail/:assetId/*'
      element={withErrorBoundary(<BuildingDetail createMode={false} />)}
    />
    <Route
      path='/buildingCreate/:type/*'
      element={withErrorBoundary(<BuildingDetail createMode />)}
    />
    <Route
      path='/peopleDetail/:partyId/*'
      element={withErrorBoundary(
        <PeopleDetails createMode={false} type='contact' />
      )}
    />
    <Route
      path='/peopleCreate/*'
      element={withErrorBoundary(<PeopleDetails createMode type='contact' />)}
    />
    <Route
      path='/userDetail/:partyId/*'
      element={withErrorBoundary(
        <PeopleDetails createMode={false} type='user' />
      )}
    />
    <Route
      path='/userCreate/*'
      element={withErrorBoundary(<PeopleDetails createMode type='user' />)}
    />
    <Route
      path='/skillsetDetail/:skillsetId/*'
      element={withErrorBoundary(<SkillsetDetails />)}
    />
    <Route
      path='/skillsetCreate/*'
      element={withErrorBoundary(<SkillsetDetails createMode />)}
    />
    <Route
      path='/addClient/*'
      element={<AddWorkflowRoutes flow='addClient' />}
    />
    <Route
      path='/addLocation/*'
      element={<AddWorkflowRoutes flow='addLocation' />}
    />
    <Route
      path='/addPeople/*'
      element={<AddWorkflowRoutes flow='addPeople' />}
    />
    <Route
      path='/addService/*'
      element={<AddWorkflowRoutes flow='addService' />}
    />
    <Route
      path='/approveClient/*'
      element={<ApprovalWorkflowRoutes flow='approveClient' />}
    />
    <Route
      path='/approveLocation/*'
      element={<ApprovalWorkflowRoutes flow='approveLocation' />}
    />
    <Route
      path='/approvePeople/*'
      element={<ApprovalWorkflowRoutes flow='approvePeople' />}
    />
    <Route
      path='/approveService/*'
      element={<ApprovalWorkflowRoutes flow='approveService' />}
    />
    <Route
      path='/approveDashboard/*'
      element={<UtilityRoutes section='approveDashboard' />}
    />
    <Route
      path='/create/*'
      element={<UtilityRoutes section='create' />}
    />
    <Route
      path='/format/*'
      element={<UtilityRoutes section='format' />}
    />
    <Route
      path='/tab/:tabName/:id/*'
      element={withErrorBoundary(<ConsumerTabs />)}
    />
    <Route
      path='/tab/:tabName/*'
      element={withErrorBoundary(<ProviderTabs />)}
    />
    <Route
      path='/goto/:pageName/*'
      element={withErrorBoundary(<RedirectionControl />)}
    />
    <Route path='*' element={<Navigate replace to='/home' />} />
  </SentryRoutes>
)

export default AppRoutes
